import DataService from "../../../services/client/classes/dataService";
import { IImage } from '../models/interfaces/iImage'
import { IQuote } from '../models/interfaces/iQuote'
import { IAboutMe } from "../models/interfaces/iAboutMe";
import { ICompany } from "../models/interfaces/iCompany";
import { ISchool } from "../models/interfaces/ISchool";
import { IEditCompanyOutput } from "../models/interfaces/memberProfile/iEditCompanyOutput";
import { IEditSchoolOutput } from "../models/interfaces/memberProfile/iEditSchoolOutput";
import { ISearch } from '../models/interfaces/iSearch'
import { IEditAddPhilanthropyOutput } from "../models/interfaces/memberProfile/iEditAddPhilanthropyOutput";
import { IDeleteExperienceOutput } from "../models/interfaces/memberProfile/iDeleteExperienceOutput";
import { ILocation } from "../models/interfaces/iLocation";
import { IGetMemberProfileDataOutput } from "../models/interfaces/memberProfile/iGetMemberProfileDataOutput";
import { IAddEditCausesOutput } from "../models/interfaces/IAddCausesOutput";
import { IFilterForCities } from "../models/interfaces/memberProfile/iFilterForCities";
import { IAddEditLocationsOutput } from "../models/interfaces/iAddEditLocationOutput";
import { IMemberFandomNonprofitsOutput } from "../models/interfaces/memberProfile/iMemberFandomNonprofitsOutput";
import { IGetMemberNetworkOutput } from "../models/interfaces/memberProfile/iGetMemberNetworkOutput";
import { IChangeMatchingStatus } from '../models/interfaces/dashboard/iChangeMatchingStatus';

class MemberProfileService extends DataService {
    constructor() {
    super('/private/database/memberProfile/');
    }

    memberProfileData(data: IGetMemberProfileDataOutput): JQuery.jqXHR<any> {
        return this.post('memberProfileData/', data);
  }

  getMemberGeneralInformation(): JQuery.jqXHR<any> {
    return this.get('getMemberGeneralInformation/');
  } 

    getMemberFandomNonprofits(data: IMemberFandomNonprofitsOutput): JQuery.jqXHR<any> {
        return this.get('getMemberFandomNonprofits/', data);
    }
    getMemberShortlistedOpportunities(): JQuery.jqXHR<any> {
        return this.get('getMemberShortlistedOpportunities/');
    }

  getMemberLocations(): JQuery.jqXHR<any> {
    return this.get('getMemberLocations/');
  }

  getMemberMetropolitanAreas(): JQuery.jqXHR<any> {
    return this.get('getMemberMetropolitanAreas/');
    }

    getMetropolitanAreas(): JQuery.jqXHR<any> {
    return this.get('getMetropolitanAreas/');
    }

  updateMemberImage(data: IImage): JQuery.jqXHR<any> {
    return this.post('updateMemberImage/', data);
  }

  updateMemberQuote(data: IQuote): JQuery.jqXHR<any> {
    return this.post('updateMemberQuote/', data);
    }

    updateMemberAboutMe(data: IAboutMe): JQuery.jqXHR<any> {
        return this.post('updateMemberAboutMe/', data);
    }

    updateWorkExperience(data: IEditCompanyOutput): JQuery.jqXHR<any> {
        return this.post('updateWorkExperience/', data);
    }

    editAddWorkExperience(data: ICompany): JQuery.jqXHR<any> {
        return this.post('editAddWorkExperience/', data);
    }

    deleteExperienseByMemberOrgKey(memberOrgKey: string) {
        return this.post('deleteExperience', { memberOrgKey });
    }

    updateSchoolExperience(data: IEditSchoolOutput): JQuery.jqXHR<any> {
        return this.post('updateSchoolExperience/', data);
    }
    updatePhilanthropyExperience(data: IEditAddPhilanthropyOutput): JQuery.jqXHR<any> {
        return this.post('updatePhilanthropyExperience/', data);
    }
    addPhilanthropyExperience(data: IEditAddPhilanthropyOutput): JQuery.jqXHR<any> {
        return this.post('addPhilanthropyExperience/', data);
    }

    editAddSchoolExperience(data: ISchool): JQuery.jqXHR<any> {
        return this.post('editAddSchoolExperience/', data);
    }

    deleteExperience(data: IDeleteExperienceOutput): JQuery.jqXHR<any> {
        return this.post('deleteExperience', data);
    }

    changeCauses(data: IAddEditCausesOutput): JQuery.jqXHR<any> {
        return this.post('changeCauses/', data);
    }
 
    getMemberNetwork(search: IGetMemberNetworkOutput): JQuery.jqXHR<any> {
        return this.post('getMemberNetwork/', search);
    }

  setMemberLocations(data: IAddEditLocationsOutput): JQuery.jqXHR<any> {
    return this.post('setMemberLocations/', data);
  }

  setMemberCurrentLocation(key: string): JQuery.jqXHR<any> {
    return this.post('setMemberCurrentLocation/', { key });
    }
    
    changeMatchingStatus(data: IChangeMatchingStatus): JQuery.jqXHR<any> {
    return this.post('changeMatchingStatus/', data);
  }

}

export default new MemberProfileService();


// WEBPACK FOOTER //
// ./static-content/private/javascripts/services/memberProfileService.ts